import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import {
    FichierModel,
    ModelEmailPjEtPubliTypModel,
    ModelesCourrierPublipostageModel,
    MutationGetCourrierEnvoyePublipostageArgs,
    MutationGetEmailEnvoyePublipostageArgs
} from 'src/graphql/generated-types';
import gql from 'graphql-tag';
import { catchError, tap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

export interface BeneficiaryDetailActivitySendDetailDialogData {
    sendHistoryId: number;
    sendHistoryType: string;
}

@Component({
    selector: 'app-shared-send-detail-dialog',
    templateUrl: './shared-send-detail-dialog.component.html',
    styleUrls: ['./shared-send-detail-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedSendDetailDialogComponent extends BaseComponent implements OnInit {

    email: ModelEmailPjEtPubliTypModel = null;

    letter: ModelesCourrierPublipostageModel = null;

    attachmentsList: FichierModel[] = [];

    constructor(private dialogRef: KalDialogRef<SharedSendDetailDialogComponent>,
                private graphqlService: GraphqlService,
                protected cdr: ChangeDetectorRef,
                @Inject(KAL_DIALOG_DATA) public data: BeneficiaryDetailActivitySendDetailDialogData) {
        super(cdr);
    }

    get shouldDisplayMailTemplate(): boolean {
        return ['MAIL', 'NEWSLETTER'].includes(this.data.sendHistoryType);
    }

    close() {
        this.dialogRef.close();
    }

    private getEmailDetail(): Observable<any> {
        return this.graphqlService.mutateOne<'GetEmailEnvoyePublipostage', MutationGetEmailEnvoyePublipostageArgs>({
            mutation: gql`
                mutation GetEmailEnvoyePublipostage($contexte: ContextInfosInput, $idHistoriqueCourrier: Float) {
                    GetEmailEnvoyePublipostage(contexte: $contexte, idHistoriqueCourrier: $idHistoriqueCourrier) {
                        ... on ModelEmailPjEtPubliTypModel {
                            EmetteurModelEmail
                            ObjectModelEmail
                            CorpsModelEmail
                            ListePJ {
                                FichierModel {
                                    Token
                                    LibelleLien
                                }
                            }
                        }
                    }
                }
            `,
            variables: {
                idHistoriqueCourrier: this.data.sendHistoryId
            }
        })
        .pipe(
            tap((GetEmailEnvoyePublipostage: ModelEmailPjEtPubliTypModel) => {
                this.email = GetEmailEnvoyePublipostage || null;
                this.attachmentsList = GetEmailEnvoyePublipostage.ListePJ?.FichierModel || [];
            })
        );
    }

    private getLetterDetail(): Observable<any> {
        return this.graphqlService.mutateOne<'GetCourrierEnvoyePublipostage', MutationGetCourrierEnvoyePublipostageArgs>({
            mutation: gql`
                mutation GetCourrierEnvoyePublipostage($contexte: ContextInfosInput, $idHistoriqueCourrier: Float) {
                    GetCourrierEnvoyePublipostage(contexte: $contexte, idHistoriqueCourrier: $idHistoriqueCourrier) {
                        Introduction
                        Objet
                        Corps
                        SignatureCE
                        VoirCoordonneeCE
                        VoirLogoCE
                        VoirLogoSignature
                    }
                }
            `,
            variables: {
                idHistoriqueCourrier: this.data.sendHistoryId
            }
        })
        .pipe(
            tap((GetCourrierEnvoyePublipostage: ModelesCourrierPublipostageModel) => {
                this.letter = GetCourrierEnvoyePublipostage || null;
            })
        );
    }

    ngOnInit(): void {
        let request: Observable<any>;

        this.loading = true;

        switch (this.data.sendHistoryType) {
            case 'NEWSLETTER':
            case 'MAIL':
                request = this.getEmailDetail();
                break;
            case 'COURRIER':
                request = this.getLetterDetail();
                break;
            default:
                request = throwError(new Error(`History type '${this.data.sendHistoryType}' not handled`));
                break;
        }

        this.watch$ = request.pipe(
            tap(() => {
                this.loading = false;
            }),
            catchError(err => {
                this.loading = false;
                return throwError(err);
            }),
        );
    }

}
